module.exports = __webpack_public_path__ + "static/media/Slide1.7a05fd75.png";